import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CalendarEntry } from '@contracts/interfaces/calendar.interface';
import { ConnectionService } from './connection.service';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {
  constructor(
    private http: HttpClient,
    private connectionService: ConnectionService
  ) {}

  find(query: any = {}) {
    return this.http.post<CalendarEntry[]>(this.connectionService.address + '/calendar-service/find', { query });
  }

  create(entry: CalendarEntry) {
    return this.http.post<{ id: string }>(this.connectionService.address + '/calendar-service/create', { entry });
  }

  update(entry: CalendarEntry) {
    return this.http.post<{ id: string }>(this.connectionService.address + '/calendar-service/update', { entry });
  }

  delete(id: string) {
    return this.http.post<{ id: string }>(this.connectionService.address + '/calendar-service/delete', { id });
  }
}
